import flashSaleGradientBg from 'src/images/pngs/campaigns/flash-sale/bg-gradient.png';
import styled from 'styled-components';

export const StyledBar = styled.div<{ isEmbedded?: boolean }>`
  position: relative;
  height: 9.7rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 1.6rem 0 2.2rem 0;
  border-radius: 0;
  flex-direction: column;
  gap: 2.4rem;

  color: ${({ theme }) => theme.colors.white};
  background: ${({ theme }) => theme.colors.offBlack};

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 0;
  }

  &:before {
    background-image: url(${flashSaleGradientBg});
  }

  ${({ isEmbedded }) =>
    isEmbedded &&
    `
      &:before {
        background-image: none;
      }
    `}

  & > * {
    position: relative;
    z-index: 1;
  }

  @media (min-width: ${({ theme }) => theme.sizes.lg}) {
    height: auto;
    padding: 1.2rem;
    text-align: center;
    flex-direction: row;
    gap: 3rem;
  }

  p {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    letter-spacing: -0.03em;
    text-align: center;
    font-size: 2.2rem;
    margin: 0;
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      margin-bottom: 1rem;
    }
  }

  p span {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  a {
    &:hover:not(:disabled) {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;

export const StyledCopyWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.large};
  letter-spacing: -0.045rem;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
  }
`;

export const StyledWrapRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 1.9rem;
  margin-top: 1.4rem;
  
  @media (min-width: ${({ theme }) => theme.sizes.md}) {
    gap: 3rem;
    margin-top: 1.5rem;
  }

  @media (min-width: ${({ theme }) => theme.sizes.lg}) {
    margin-top: 0;
  }
`;
